






































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VHeaders, PaginationModel } from '@/models/pagedlistmodel';
import { InspectionForms } from '@/models/admin/inspection.form';
import { Base } from '@/components/common/base';
import { VFields } from '@/models/v-fields';
import { IDialogOption } from '@/models/dialog';
import {getHeaders } from '@/views/admin/inspectionforms/inspectionForms';
import {inspectionFormService} from '@/shared';

@Component({
    props: ['methodName', 'progress'],
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    },
    components: {
        Stores: () => import('@/components/common/store.select.vue'),
        Grid: () => import('@/components/common/app.grid.vue'),
        AppDialog: () => import('@/components/common/app.dialog.vue'),
    },
})
export default class InspectionFormListPage extends Base {
    public form: any = {};
    public headers: VHeaders[] = getHeaders(this);

    public inspectionForms: any[] = [];
    public pagedInspectionForms: any[] = [];

    public pagination = new PaginationModel('name');
    public loading: boolean = false;
    public deleteDialog: IDialogOption = {
        width: 400,
        title: this.$parent.$t('inspectionForms.deleteDialogTitle') as string,
        model: false,
        action: { color: 'success', icon: 'fas fa-check', text: 'Agree' },
        loading: false,
        onAction: (): void => {
            this.deleteInspectionForm();
        },
    };
    public storeId: number = 0;
    public inspectionFormIdToDelete: number = 0;
    public actions: any[] = [];
    public inspectionFormFields: Array<VFields<any>> = [];
    public items: any[] = [{ key: '0', value: 'New' }, { key: '1', value: 'Used' }]; // [ 'New', 'Used' ]
    public vehicleType: string = '';
    public setActions() {
        this.actions = [{
            type: 'link',
            icon: 'fas fa-edit',
            title: this.$t('inspectionForms.inspectionFormGridHeaders.gridAction.edit') as string,
            disable: (model: InspectionForms) => {
                if (model.isEditable) {
                    return false;
                } else {
                    return true;
                }
            },
            action: (model: InspectionForms) => {
                return {
                    name: 'admin.inspection.forms.edit',
                    params: {
                        id: model.id,
                        storeId: this.storeId,
                        type: this.vehicleType.toString(),
                    },
                };
            },
        },
        ];
    }

    public created() {
        this.storeId = Number(this.$route.params.storeId) ?
            Number(this.$route.params.storeId) : Number(this.userSession.storeId);
        this.vehicleType = this.$route.params.type ? this.$route.params.type : '0';
    }

    public beforeDestroy() {
        const buttons = [];
        this.$emit('updateToolBar', buttons);
    }
    public callMethod(methodName): void {
        if (methodName === 'addInspectionForm') {
            this.$router.push({ name: 'admin.inspection.forms.add', params: { storeId: this.storeId.toString(), type: this.vehicleType.toString() } });
        }
    }
    public updateToolBar(): void {
        const buttons: any = [];
        buttons.push({ id: '0', type: 'button', title: this.$t('inspectionForms.btnAddInspectionForm'), disabled: false, visible: true, class: 'btn', label: this.$t('inspectionForms.btnAddInspectionForm'), click: 'addInspectionForm', icon: 'fas fa-plus-circle' });
        this.$emit('updateToolBar', buttons);
    }
    public mounted() {
        // activating tab
        this.$root.$emit('sidebar.layout.vue', 'inspectionForms');
        
        // Toolbar
        this.updateToolBar();
        this.$watch('methodtoCall', (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });

        this.setActions();
        this.getInspectionForms();
    }

    public async getInspectionForms(): Promise<void> {
        try {
            this.loading = true;
            this.storeId = this.storeId !== 0 ?
                this.storeId : Number(this.$route.params.storeId) !== undefined ?
                    Number(this.$route.params.storeId) : Number(this.userSession.storeId);
            const response = await inspectionFormService.getInspectionFormSelectList(this.storeId);
            this.inspectionForms = response;
            this.pagination.totalItems = response.length;

            if (this.vehicleType && this.inspectionForms.length > 0) {
                this.filterByVehicleType(this.vehicleType);
            }
        } finally {
            this.loading = false;
        }
    }

    public filterByVehicleType(selectedVehicleType): void {
        if (this.inspectionForms.length > 0) {
            this.pagedInspectionForms = this.inspectionForms.filter((m) => {
                return m.type === ((selectedVehicleType === '0') ? 'New' : 'Used');
            });
            this.pagination.totalItems = this.pagedInspectionForms.length;
        }
    }

    public async deleteInspectionForm(): Promise<void> {
        try {
            this.deleteDialog.loading = true;
            await inspectionFormService.deleteInspectionForm(this.inspectionFormIdToDelete);
            this.showAlert(true, this.$t('inspectionForms.alertDeleteInspectionForm'));
            this.getInspectionForms();
        } finally {
            this.deleteDialog.loading = false;
            this.deleteDialog.model = false;
        }
    }

    public updatePaging(paging: any) {
        this.pagination = paging;
    }

    public updateStore(storeId: number): void {
        if (storeId !== 0) {
            this.storeId = storeId;
            this.getInspectionForms();
        }
    }

    public checkUserRole(routeRoles: string[]): boolean {
        return this.isAuthorizedToAccess(routeRoles);
    }
}
